/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */


App.ready(() => App.syntax_highlighting.init());


App.syntax_highlighting = {

  init() {
    return $('pre code').each(function() {
      return hljs.highlightBlock(this);
    });
  }
};
